/*global define*/
define([
    'jquery',
    'underscore',
    'backbone',
    './Nav',
    '../models/Workbench',
    './Workbench',
    '../resources/glassware',
    '../collections/Vessel',
    '../collections/Tool',
    './Assignment',
    './InstrumentPanel',
    './Stockroom',
    '../resources/assignments',
    '../chemistry/KnowledgeBase',
    '../collections/Workbench',
    '../resources/tools',
    'postal',
    'logging/XMLUtility',
    '../chemistry/LiquidVolumeSolutionModeler',
    '../chemistry/SolventConcentrationSolutionModeler',
    '../chemistry/SpecificHeatSolutionModeler',
    '../chemistry/SolventSolutionModeler',
    '../chemistry/BoilingPointSolutionModeler',
    '../chemistry/FreezingPointSolutionModeler',
    '../resources/lang',
    '../UnknownClientSide',
    '../Configuration',
    './replaceUnknowns',
    '../../styles/local.module.scss'
], function ($,
             _,
             Backbone,
             NavView,
             WorkbenchModel,
             WorkbenchView,
             glassware,
             VesselCollection,
             ToolCollection,
             AssignmentView,
             InstrumentPanelView,
             StockroomView,
             assignments,
             KnowledgeBase,
             WorkbenchCollection,
             tools,
             postal,
             XMLUtility,
             LiquidVolumeSolutionModeler,
             SolventConcentrationSolutionModeler,
             SpecificHeatSolutionModeler,
             SolventSolutionModeler,
             BoilingPointSolutionModeler,
             FreezingPointSolutionModeler,
             lang,
             Unknown,
             Configuration,
             replaceUnknowns,
             styles) {
    'use strict';

    var AppView = Backbone.View.extend({

        tagName: 'App',
        template: require('ejs-loader!../templates/App.ejs'),
        styles: styles,
        kb: null,
        solutions: null,
        majorVersion: 0,
        minorVersion: 7,
        buildNumber: 0,
        versionFlag: null,
        buildDate: "July 17, 2024",
        defaults: {

        },
        events: {
            'click .addWorkbenchButton': 'addWorkbench',
            'click .renameWorkbenchButton': 'renameWorkbench',
            'click .deleteWorkbenchButton': 'deleteWorkbench',
            'click .setWorkbenchButton': 'setWorkbench',
            'click .aboutVlab': 'displayAboutModal',
            'pointerdown .addSolution' : 'addSolutionToWorkbench',
            'pointerdown .addGlassware' : 'addGlasswareToWorkbench',
            'pointerdown .addTool' : 'addToolToWorkbench',
            'click .stockroomTab' : 'toggleStockroom',
            'click .selectAssignment': 'loadAssignment',
            'pointerdown .vessel' : 'selectVessel',
            'click .branch' : 'branchHandler',
            'click .removeSolid' : 'removeSolid',
            'click .removeLiquid' : 'removeLiquid',
            'click .detailView' : 'detailView',
            'click .duplicateVessel' : 'duplicateVessel',
            'click .thermalProperties' : 'vesselThermalProperties',
            'click .renameVessel' : 'renameVessel',
            'click .removeVessel' : 'removeVessel',
            'click .removeTool' : 'removeTool',
            'click #toAssignmentModal' : 'showAssignmentModal',
            'click .clearWorkbench' : 'clearWorkbench',
            'click .navbar-toggle': 'toggleNavbar',
            'click .helpItem': 'toggleHelp',
            'click .tips': 'displayTipsModal',
            'click #stockroomHeader': 'showStockroom',
            'click #presentationMode': 'presentationMode',
            'click #workbenchZoomOut': 'zoomOut',
            'click #workbenchZoomIn': 'zoomIn',
            'click #workbenchResetZoom': 'resetZoom',
            'click #changeLanguage': 'changeLanguage'
        },
        initialize: async function(options){
            this.styles = styles;
            this.domain = (options && options.domain) || ''; // Set domain to fetch svg / image assets from...

            $("html").attr("lang", language);

            $("#vlab").css("height", $(document).height());

            this.finishedLoading = false;

            var logger = postal.channel("logger");
            if (Unknown.unknownString) {
                logger.publish("vlabUnknownsSet", {unknownString: Unknown.unknownString});
            }

            var appChannel = postal.channel("app");
            var subscriptions = [
                appChannel.subscribe("finishedLoadingRequest", function(){
                    appChannel.publish("finishedLoading", {finishedLoading: this.isFinishedLoading()});
                }.bind(this)),
                appChannel.subscribe("selectedVesselRequest", function(){
                    appChannel.publish("selectedVessel", {selectedVessel: this.getSelectedVessel()});
                }.bind(this)),
                appChannel.subscribe("workbenchItemsRequest", function(){
                    appChannel.publish("workbenchItems", {workbenchItems: this.getWorkbenchItems()});
                }.bind(this)),
                appChannel.subscribe("loadAssignment", function(){
                    console.log("received external loadAssignment request");
                    this.loadAssignment();
                }.bind(this)),
                appChannel.subscribe("loadAssignmentJSON", function(data){
                    console.log("received external loadAssignmentJSON request");
                    this.loadAssignmentJSON(data);
                }.bind(this))
            ];

            // Set up the containers and app structure
            this.render();

            //$(window).resize(this.adjustColumns);
            $(window).resize(this.adjust);

            // Shortly display welcome screen
            this.displayAboutModal(1000);

            var assignmentView = new AssignmentView(this.domain);
            var navView = new NavView({model: this.model, el: $(this.$el).find('#navbarContainer')});
            var stockroomView = new StockroomView({el: $(this.$el).find("#stockroomContainer"), domain: this.domain});
            var instrumentPanelView = new InstrumentPanelView({model: this.model, el: $(this.$el).find("#instrumentPanelContainer")});
            this.model.set("assignmentView", assignmentView);
            this.model.set("navView", navView);
            this.model.set("stockroomView", stockroomView);
            this.model.set("instrumentPanelView", instrumentPanelView);
            //this.model.set("userScaleFactor", 1.0);
            if (options && options.vlab) {
                await this.loadAssignmentJSON(options.vlab); // maybe still needs await?
            }

            stockroomView.open();

            this.finishedLoading = true;
            logger.publish("vlabInitialized", {majorVersion: this.majorVersion, minorVersion: this.minorVersion, buildNumber: this.buildNumber, versionString: this.getVersionString()});
        },
        render: function(){
            var dimensions = [$(window).width(), $(window).height()];
            var renderedTemplate = this.template({width: dimensions[0],height: dimensions[1], terms: _.extend({}, lang.app, lang.actions), language: language});
            this.$el.html(renderedTemplate);
            this.adjust();
        },
        adjust: function() {
            var height = $(window).height();
            $("#vlab").height(height);
            $("#stockroomContainer").height(height - 155);
            $("#instrumentPanelContainer").height(height - 205);
            $(".workbench").height(height - 150);
        },
        // adjustColumns: function(){
        //     var width = $("#vlab").width();
        //     var informationColumn = $("#informationColumn");
        //     var workbenchColumn = $("#workbenchColumn");
        //     if(width < 768 ){
        //         informationColumn.removeClass();
        //         informationColumn.addClass("col-sm-5");
        //         workbenchColumn.removeClass();
        //         workbenchColumn.addClass("col-sm-7");
        //     }else if( width >= 768 && width <= 991){
        //         informationColumn.removeClass();
        //         informationColumn.addClass("col-sm-4");
        //         workbenchColumn.removeClass();
        //         workbenchColumn.addClass("col-sm-8");
        //     }else{
        //         informationColumn.removeClass();
        //         informationColumn.addClass("col-sm-3");
        //         workbenchColumn.removeClass();
        //         workbenchColumn.addClass("col-sm-9");
        //     }
        // },
        showStockroom: function(){
            $(".selectedVessel").removeClass("selectedVessel");
            // $("#view").addClass("disabled");

            $("#instrumentPanel").css("display", "none");
            $("#stockroomContainer").css("display", "block");
            $("#openStockroom").css("display", "none");
        },
        showInstrumentPanel: function(){
            $("#instrumentPanel").css("display", "block");
            $("#stockroomContainer").css("display", "none");
            $("#openStockroom").css("display", "block");
        },
        toggleStockroom: function(event){var stockroomView = this.model.get("stockroomView");
            if ($(event.target).attr("id") === undefined){
                stockroomView.switchTab("solutions");
                $("#solutions").addClass("selected");
            }
            else{
                stockroomView.switchTab($(event.target).attr("id"));
            }
        },
        /*toggleInstrumentPanel: function(){
            var instrumentPanelView = this.model.get("instrumentPanelView");
            if ($("#instrumentPanelContainer").hasClass("instrumentPanelClosed")) {
                instrumentPanelView.open();
            }
            else {
                instrumentPanelView.close();
            }
        },*/
        loadAssignment: function(event){
            var path = "scripts/resources/assignments/"+language+"/";
            if (event) {
                path += $(event.currentTarget).attr("id");
                $("#assignmentModal").modal("hide");
            }
            else if (assignmentPath) {
                path += assignmentPath;
                $.ajax({
                    url: path+"/configuration.json",
                    async: false,
                    error: function(){
                        // path = "scripts/resources/assignments/"+language+"/"+assignmentPath;
                        path = "scripts/resources/assignments/"+language+"/default";
                    }
                });
            }
            else {
                path += "default";
            }
            var instrumentPanel = this.model.get("instrumentPanelView");
            var nav = this.model.get("navView");
            // All of the JSON files... Let's make sure unknowns are loaded here.
            var unknown = Unknown();
            var assignmentName, assignmentText, assignmentSpecies, assignmentReactions, assignmentSpectra, solutionModellers;
            var that = this;
            var channel = postal.channel("logger");

            $.getJSON(path+"/configuration.json").done(function(data) {
                console.log("configuration loaded");
                data = replaceUnknowns(data, unknown.unknowns)
                assignmentName = data.title;
                if (assignmentName !== undefined && assignmentText !== undefined) {
                    that.setAssignmentInfo(assignmentName, assignmentText);
                }
                instrumentPanel.loadViewerConfiguration(data.solutionViewers);
                solutionModellers = data.solutionModellers || {};
                that.equilibriumSettings = {liquidUnitActivity: true, ...data.equilibriumSettings};
                SolventConcentrationSolutionModeler.loadProperties(solutionModellers.waterConcentration || solutionModellers.solventConcentration || "waterInfinite");
                LiquidVolumeSolutionModeler.loadProperties(solutionModellers.liquidVolume || "nominal");
                SpecificHeatSolutionModeler.loadProperties(solutionModellers.specificHeat || "default");
                SolventSolutionModeler.loadProperties(solutionModellers.solvent || "water");
                BoilingPointSolutionModeler.loadProperties(solutionModellers.boilingPoint || "nominal");
                FreezingPointSolutionModeler.loadProperties(solutionModellers.freezingPoint || "nominal");
                if (assignmentSpecies && assignmentReactions && assignmentSpectra && solutionModellers) {
                    that.kb = new KnowledgeBase(assignmentSpecies, assignmentReactions, assignmentSpectra, solutionModellers.waterConcentration==="waterFinite" || solutionModellers.solventConcentration==="waterFinite");
                }
                var str = JSON.stringify(data);
                that.honorSignificantFigures = str.indexOf('"honorSignificantFigures":true') !== -1 || str.indexOf('"id":"solutionProperties"') === -1;
                Configuration.showVesselStats = str.indexOf('"id":"solutionProperties"') !== -1 && str.indexOf('"id":"thermometer"') !== -1
                that.transferModes = data.transfer;
                that.assignmentTips = data.assignmentTips;
                that.model.set("workbenchCount", 1);
                that.model.set("workbenches", new WorkbenchCollection());
                that.addWorkbench();
                instrumentPanel.update();
                that.updateVessels();
            });
            $.getJSON(path+"/assignment.json").done(function(data) {
                console.log("assignment loaded");
                data = replaceUnknowns(data, unknown.unknowns)
                assignmentText = data.assignmentText;
                var index = 0;
                while (assignmentText.indexOf("<img", index) !== -1) {
                    index = assignmentText.indexOf("src=\"", index) + 5;
                    assignmentText = assignmentText.slice(0, index) + path + "/" + assignmentText.slice(index);
                }
                if (assignmentName !== undefined && assignmentText !== undefined) {
                    that.setAssignmentInfo(assignmentName, assignmentText);
                }
            });
            $.getJSON(path+"/species.json").done(function(data) {
                console.log("species loaded");
                data = replaceUnknowns(data, unknown.unknowns)
                assignmentSpecies = data.SPECIES_LIST.SPECIES;
                if (assignmentSpecies && assignmentReactions && assignmentSpectra && solutionModellers) {
                    that.kb = new KnowledgeBase(assignmentSpecies, assignmentReactions, assignmentSpectra, solutionModellers.waterConcentration==="waterFinite" || solutionModellers.solventConcentration==="waterFinite");
                }
            });
            $.getJSON(path+"/reactions.json").done(function(data) {
                console.log("reactions loaded");
                data = replaceUnknowns(data, unknown.unknowns)
                assignmentReactions = [];
                var i;
                for (i = 0; i < data.REACTIONS.REACTION.length; i++) {
                    // assignmentReactions is a list of reactions - cutting through all the cruft in the JSON file
                    assignmentReactions.push(data.REACTIONS.REACTION[i]);
                    // Need to be able to pass in additional kinetics information, so keep SPECIES_REF here...
                }
                if (assignmentSpecies && assignmentReactions && assignmentSpectra && solutionModellers) {
                    that.kb = new KnowledgeBase(assignmentSpecies, assignmentReactions, assignmentSpectra, solutionModellers.waterConcentration==="waterFinite" || solutionModellers.solventConcentration==="waterFinite");
                }
            });
            $.getJSON(path+"/spectra.json").done(function(data) {
                console.log("spectra loaded");
                data = replaceUnknowns(data, unknown.unknowns)
                assignmentSpectra = data.SPECTRA_LIST.SPECIES;
                if (assignmentSpecies && assignmentReactions && assignmentSpectra && solutionModellers) {
                    that.kb = new KnowledgeBase(assignmentSpecies, assignmentReactions, assignmentSpectra, solutionModellers.waterConcentration==="waterFinite" || solutionModellers.solventConcentration==="waterFinite");
                }
            });
            $.getJSON(path+"/solutions.json").done(function(data) {
                console.log("solutions loaded");
                data = replaceUnknowns(data, unknown.unknowns)
                var assignmentSolutions = data.FILESYSTEM.DIRECTORY;
                var stockroomView = that.model.get("stockroomView");
                stockroomView.loadSolutions(assignmentSolutions);
                that.solutions = assignmentSolutions;
            });
            this.showStockroom();
            // $("#view").addClass("disabled");
            $(".viewerList").find(".viewDivider").remove();
            channel.publish("vlabProblemLoaded", {path: path});

            // $("#joyRideTipContent").joyride({
            //     autoStart: true,
            //     postStepCallback: function(index, tip) {
            //         if (index == 2)
            //             $(this).joyride("set_li", false, 1);
            //     },
            //     modal: true,
            //     expose:true
            // });
        },

        loadAssignmentJSON: async function(data){
            // pass in the data directly - this is an object containing 6 keys, with
            // each key containing the data from one of the 6 files in the virtual lab:
            // (configuration, assignment, species, reactions, spectra, solutions)
            
            if (typeof data === "string") {
                data = await fetch(data);
                data = await data.json();
            }

            var instrumentPanel = this.model.get("instrumentPanelView");
            var nav = this.model.get("navView");
            // All of the JSON files... Let's make sure unknowns are loaded here.
            var unknown = Unknown();
            var assignmentName, assignmentText, assignmentSpecies, assignmentReactions, assignmentSpectra, solutionModellers;
            var that = this;
            var channel = postal.channel("logger");

            const configurationFunc = (data) => {
                console.log("configuration loaded");
                data = replaceUnknowns(data, unknown.unknowns)
                assignmentName = data.title;
                if (assignmentName !== undefined && assignmentText !== undefined) {
                    that.setAssignmentInfo(assignmentName, assignmentText);
                }
                instrumentPanel.loadViewerConfiguration(data.solutionViewers);
                solutionModellers = data.solutionModellers || {};
                SolventConcentrationSolutionModeler.loadProperties(solutionModellers.waterConcentration || solutionModellers.solventConcentration || "waterInfinite");
                that.equilibriumSettings = {liquidUnitActivity: true, ...data.equilibriumSettings};
                LiquidVolumeSolutionModeler.loadProperties(solutionModellers.liquidVolume || "nominal");
                SpecificHeatSolutionModeler.loadProperties(solutionModellers.specificHeat || "default");
                SolventSolutionModeler.loadProperties(solutionModellers.solvent || "water");
                BoilingPointSolutionModeler.loadProperties(solutionModellers.boilingPoint || "nominal");
                FreezingPointSolutionModeler.loadProperties(solutionModellers.freezingPoint || "nominal");
                if (assignmentSpecies && assignmentReactions && assignmentSpectra && solutionModellers) {
                    that.kb = new KnowledgeBase(assignmentSpecies, assignmentReactions, assignmentSpectra, solutionModellers.waterConcentration==="waterFinite" || solutionModellers.solventConcentration==="waterFinite");
                }
                var str = JSON.stringify(data);
                that.honorSignificantFigures = str.indexOf('"honorSignificantFigures":true') !== -1 || str.indexOf('"id":"solutionProperties"') === -1;
                Configuration.showVesselStats = str.indexOf('"id":"solutionProperties"') !== -1 && str.indexOf('"id":"thermometer"') !== -1
                that.transferModes = data.transfer;
                that.assignmentTips = data.assignmentTips;
                that.model.set("workbenchCount", 1);
                that.model.set("workbenches", new WorkbenchCollection());
                that.addWorkbench();
                instrumentPanel.update();
                that.updateVessels();
            };

            const assignmentFunc = (data) => {
                console.log("assignment loaded");
                data = replaceUnknowns(data, unknown.unknowns)
                assignmentText = data.assignmentText;
                var index = 0;
                while (assignmentText.indexOf("<img", index) !== -1) {
                    index = assignmentText.indexOf("src=\"", index) + 5;
                    assignmentText = assignmentText.slice(0, index) + path + "/" + assignmentText.slice(index);
                }
                if (assignmentName !== undefined && assignmentText !== undefined) {
                    that.setAssignmentInfo(assignmentName, assignmentText);
                }
            };

            const speciesFunc = (data) => {
                console.log("species loaded");
                data = replaceUnknowns(data, unknown.unknowns)
                assignmentSpecies = data.SPECIES_LIST.SPECIES;
                if (assignmentSpecies && assignmentReactions && assignmentSpectra && solutionModellers) {
                    that.kb = new KnowledgeBase(assignmentSpecies, assignmentReactions, assignmentSpectra, solutionModellers.waterConcentration==="waterFinite" || solutionModellers.solventConcentration==="waterFinite");
                }
            };

            const reactionsFunc = (data) => {
                console.log("reactions loaded");
                data = replaceUnknowns(data, unknown.unknowns)
                assignmentReactions = [];
                var i;
                for (i = 0; i < data.REACTIONS.REACTION.length; i++) {
                    assignmentReactions.push(data.REACTIONS.REACTION[i]);
                }
                if (assignmentSpecies && assignmentReactions && assignmentSpectra && solutionModellers) {
                    that.kb = new KnowledgeBase(assignmentSpecies, assignmentReactions, assignmentSpectra, solutionModellers.waterConcentration==="waterFinite" || solutionModellers.solventConcentration==="waterFinite");
                }
            };

            const spectraFunc = (data) => {
                console.log("spectra loaded");
                data = replaceUnknowns(data, unknown.unknowns)
                assignmentSpectra = data.SPECTRA_LIST.SPECIES;
                if (assignmentSpecies && assignmentReactions && assignmentSpectra && solutionModellers) {
                    that.kb = new KnowledgeBase(assignmentSpecies, assignmentReactions, assignmentSpectra, solutionModellers.waterConcentration==="waterFinite" || solutionModellers.solventConcentration==="waterFinite");
                }
            };

            const solutionsFunc = (data) => {
                console.log("solutions loaded");
                data = replaceUnknowns(data, unknown.unknowns)
                var assignmentSolutions = data.FILESYSTEM.DIRECTORY;
                var stockroomView = that.model.get("stockroomView");
                stockroomView.loadSolutions(assignmentSolutions);
                that.solutions = assignmentSolutions;
            };

            configurationFunc(data['configuration']);
            assignmentFunc(data['assignment']);
            speciesFunc(data['species']);
            reactionsFunc(data['reactions']);
            spectraFunc(data['spectra']);
            solutionsFunc(data['solutions']);


            this.showStockroom();
            // $("#view").addClass("disabled");
            $(".viewerList").find(".viewDivider").remove();
            channel.publish("vlabProblemLoaded", {path: 'loaded-from-object!'});

            // $("#joyRideTipContent").joyride({
            //     autoStart: true,
            //     postStepCallback: function(index, tip) {
            //         if (index == 2)
            //             $(this).joyride("set_li", false, 1);
            //     },
            //     modal: true,
            //     expose:true
            // });
        },
        setAssignmentInfo: function (name, text) {
            this.assignmentName = name;
            this.assignmentText = text;
            var button = $("#assignmentName");
            button.html(name);
            button.unbind("click");
            button.on("click", this.showAssignmentTextModal.bind(this));
        },
        selectVessel: function(event){
            if ($(event.target).parents(".vessel")[0] !== undefined){

                var vesselCid =  $($(event.target).parents(".vessel")[0]).attr("id");

                var currentWorkbenchCid = this.model.get('currentWorkbenchCid');
                var workbenches = this.model.get('workbenches');
                var workbench = workbenches.get(currentWorkbenchCid);
                var currentVessels = workbench.get("vesselCollection");
                var vessel = currentVessels.get(vesselCid);
                var channel = postal.channel("logger");
                channel.publish("selectionChanged", {oldSelected: [currentVessels.get(workbench.get("currentVesselCid"))], selected: [vessel], workbench: workbench});

                $(".selectedVessel").removeClass('selectedVessel');
                // un select currently vessel
                $("#"+vesselCid).addClass("selectedVessel");

                // select this vessel
                workbench.set("currentVesselCid", vesselCid);
                var instrumentPanel = this.model.get("instrumentPanelView");
                if (!instrumentPanel.vessel) {
                    $("gg").parent().find(".viewerList").prepend('<li class="divider viewDivider"></li>');
                }
                instrumentPanel.update(vessel);
                this.showInstrumentPanel();

                // $("#view").removeClass("disabled");
            }
        },
		addWorkbench: function(event){
            if (event) {
                $("#file").dropdown("toggle");
            }
            var workbenches = this.model.get('workbenches');
            var workbenchCount = this.model.get('workbenchCount');

        	var workbenchModel = new WorkbenchModel({
                vesselCollection: new VesselCollection(),
                vesselViews: {},
                toolCollection: new ToolCollection(),
                toolViews: {},
                displayName: lang.app.workbench[language]+" "+workbenchCount,
                app: this.model,
                currentVesselCid: undefined
            });

            workbenchModel.on("change:currentVesselCid", function(model, vesselCid) {
                $(".selectedVessel").removeClass('selectedVessel');
                // un select currently vessel
                $("#"+vesselCid).addClass("selectedVessel");
            });

        	//var model = new Backbone.Model();
		  	// model.set({app: this.model, workbench: newWorkbench}); // Combine the app and workbench into a single model
        	var workbenchView = new WorkbenchView({
        		model: workbenchModel,
        		collection: workbenches,
        		el: this.$el.find('#workbenchContainer')
        	});
            workbenchView.loadTransferModes(this.transferModes);

            // To keep track of the workbench view
        	var wbViews = this.model.get('workbenchViews');
        	wbViews[workbenchModel.cid] = workbenchView;

            // Undelegate events in the old workbench view
            if (this.model.get("currentWorkbenchCid")) {
                wbViews[this.model.get("currentWorkbenchCid")].undelegateEvents();
            }

            this.model.set('workbenchViews', wbViews);
	        workbenches.add(workbenchModel);
            this.model.set('workbenches', workbenches);
            this.model.set('currentWorkbenchCid', workbenchModel.cid);
            this.model.set('workbenchCount', workbenchCount+1);

            this.model.renderCurrentWorkbench();

            this.showStockroom();
            // $("#view").addClass("disabled");
        },
        setWorkbench: function (event){
            var wbCid = $(event.currentTarget).attr("wbcid");
            var wbViews = this.model.get('workbenchViews');
            wbViews[this.model.get("currentWorkbenchCid")].undelegateEvents();
            this.model.set("currentWorkbenchCid", wbCid);
            wbViews[this.model.get("currentWorkbenchCid")].delegateEvents();
            this.model.renderCurrentWorkbench();

        },
        deleteWorkbench: function (event){
            event.stopPropagation();
            var wbCid = $(event.target).attr('wbcid');
            var wbs = this.model.get('workbenches');
            var wbViews = this.model.get('workbenchViews');
            wbViews[wbCid].undelegateEvents();
            if (wbs.length > 1){
                var currentWb = wbs.get(wbCid);
                currentWb.destroy();
                wbs.remove(currentWb);
                delete wbViews[wbCid];

                this.model.set('workbenches', wbs);
                this.model.set('workbenchViews', wbViews);
                this.model.set('currentWorkbenchCid', wbs.models[0].cid);
                wbViews[this.model.get("currentWorkbenchCid")].delegateEvents();
                this.model.renderCurrentWorkbench();
            }
        },
        addSolutionToWorkbench: function(event){
            var element = $(event.target);
            while (!element.attr("id")) {
                element = element.parent();
            }
            var indices = element.attr("id");
            var indexList = indices.split(",");
            var categoryIndex = indexList[0];
            var categoryIndex1 = indexList[1];
            var solutionIndex = indexList[2];
            var solutionToAdd;
            if (solutionIndex) {
                solutionToAdd = this.solutions[categoryIndex].DIRECTORY[categoryIndex1].SOLUTION[solutionIndex];
            }
            else {
                solutionToAdd = this.solutions[categoryIndex].SOLUTION[categoryIndex1];
            }
            solutionToAdd.kb = this.kb;
            solutionToAdd.origin = "STOCKROOM";
            solutionToAdd.equilibriumSettings = this.equilibriumSettings;
            solutionToAdd.honorSignificantFigures = this.honorSignificantFigures;
            var vessel = solutionToAdd.vessel || "250mLFlask";

            var currentWorkbenchCid = this.model.get('currentWorkbenchCid');
            var workbenches = this.model.get('workbenches');
            var workbench = workbenches.get(currentWorkbenchCid);
            var currentVesselCid = workbench.get("currentVesselCid");
            $("#" + currentVesselCid).removeClass("selectedVessel");
            workbench.addSolution(solutionToAdd, vessel);
            currentVesselCid = workbench.get("currentVesselCid");
            $("#" + currentVesselCid).addClass("selectedVessel");
            var vesselCollection = workbench.get("vesselCollection");
            var instrumentPanel = this.model.get("instrumentPanelView");
            if (!instrumentPanel.vessel) {
                $("#view").parent().find(".viewerList").prepend('<li class="divider viewDivider"></li>');
            }
            instrumentPanel.update(vesselCollection.get(currentVesselCid));
            this.showInstrumentPanel();
            // $("#view").removeClass("disabled");
        },
        addGlasswareToWorkbench: function(event){
            var element = $(event.target);
            while (!element.attr("id")) {
                element = element.parent();
            }
            var indices = element.attr("id");
            var indexList = indices.split(",");
            var categoryIndex = indexList[0];
            var glasswareIndex = indexList[1];

            var glasswareToAdd = glassware[categoryIndex][glasswareIndex];
            var vessel = glasswareToAdd.name;

            var currentWorkbenchCid = this.model.get('currentWorkbenchCid');
            var workbenches = this.model.get('workbenches');
            var workbench = workbenches.get(currentWorkbenchCid);
            var currentVesselCid = workbench.get("currentVesselCid");
            $("#" + currentVesselCid).removeClass("selectedVessel");
            var instrumentPanel = this.model.get("instrumentPanelView");
            if (!instrumentPanel.vessel) {
                $("#view").parent().find(".viewerList").prepend('<li class="divider viewDivider"></li>');
            }
            workbench.addSolution({
                kb: this.kb,
                species: [],
                name: lang.glassware[vessel][language],
                origin: "TOOL BAR",
                honorSignificantFigures: this.honorSignificantFigures
            }, vessel);
            currentVesselCid = workbench.get("currentVesselCid");
            $("#" + currentVesselCid).addClass("selectedVessel");
        },
        addToolToWorkbench: function(event){
            var element = $(event.target);
            while (!element.attr("id")) {
                element = element.parent();
            }
            var index = element.attr("id");
            var toolToAdd = tools[index];
            var tool = toolToAdd.name;
            var currentWorkbenchCid = this.model.get("currentWorkbenchCid");
            var workbenches = this.model.get("workbenches");
            var workbench = workbenches.get(currentWorkbenchCid);
            workbench.addTool(tool);
        },
        displayAboutModal: function (timer){
            var about = $(require('ejs-loader!../templates/Modal.ejs')(
                {buildDate: this.buildDate, terms: lang.about,
                    language: language, domain: this.domain}));
            $(about).on('hidden.bs.modal', function (e) {
                if (!localStorage.returningUser && showFirstTimeTips) {
                    this.displayTipsModal();
                    localStorage.returningUser = true;
                }
                else {
                    $("body").removeClass("modal-open");
                    $('.modal-backdrop').remove();
                    $("#aboutModal").remove();
                }
            }.bind(this));
            $(about).modal({
                keyboard: true
            });
            if (typeof(timer) === "number") {
                setTimeout(function(){
                    $(about).modal("hide");
                }, timer);
            }
        },
        displayTipsModal: function() {
            var tips = [];
            if (this.assignmentTips) {
                if (showFirstTimeTips)
                    tips = tips.concat([lang.tips.tip1[language], lang.tips.tip2[language]]);
                tips = tips.concat(this.assignmentTips)
            }
            else
                tips = tips.concat([lang.tips.tip1[language], lang.tips.tip2[language]]);

            var modal = $(require("ejs-loader!../templates/TipsModal.ejs")({
                terms: lang.tips,
                language: language
            }));
            $(modal).on("hidden.bs.modal", function() {
                $("body").removeClass("modal-open");
                $(".modal-backdrop").remove();
                $("#tipsModal").remove();
            });
            $(modal).modal({backdrop:false});
            this.$el.append(modal);
            var index = 0;
            var tipContent = $("#tipContent");
            var tipsProgress = $("#tipsProgress");
            var nextTip = $("#nextTip");
            var previousTip = $("#previousTip");
            var gotIt = $("#gotIt");
            tipContent.html(tips[index]);
            tipsProgress.html((index + 1) + "/" +tips.length);
            nextTip.on("click", function() {
                index++;
                tipContent.html(tips[index]);
                tipsProgress.html((index + 1) + "/" + tips.length);
                if (index >= tips.length - 1) {
                    nextTip.css("display", "none");
                    gotIt.css("display", "block");
                }
                previousTip.css("display", "block")
            });
            previousTip.on("click", function() {
                index--;
                tipContent.html(tips[index]);
                tipsProgress.html((index + 1) + "/" + tips.length);
                if (index <= 0)
                    previousTip.css("display", "none");
                gotIt.css("display", "none");
                nextTip.css("display", "block");
            });
            gotIt.on("click", function() {
                $(modal).modal("hide");
            });
        },
        removeSolid: function (event) {
            if ($(event.target).hasClass("editItem")) {
                $("#edit").dropdown("toggle");
            }
            var currentWorkbenchCid = this.model.get("currentWorkbenchCid");
            var workbenches = this.model.get("workbenches");
            var workbench = workbenches.get(currentWorkbenchCid);
            var vesselCid = workbench.get("currentVesselCid");
            var vessel = workbench.get("vesselCollection").get(vesselCid);
            var solution = vessel.get("solution");
            var pre = solution.clone();
            solution.filtrate();
            var channel = postal.channel("logger");
            channel.publish("actionUsed", {name: "FILTRATE", relevantInfo: {pre: pre, post: solution}});
            vessel.set("solution", solution);
            vessel.set("species", solution.getSpeciesData());
            vessel.set("volume", solution.getVolume());
            vessel.set("solidVolume", solution.getSolidVolume());
            vessel.setVolumeString();
            var instrumentPanel = this.model.get("instrumentPanelView");
            instrumentPanel.update(vessel);
        },
        removeLiquid: function (event) {
            if ($(event.target).hasClass("editItem")) {
                $("#edit").dropdown("toggle");
            }
            var currentWorkbenchCid = this.model.get("currentWorkbenchCid");
            var workbenches = this.model.get("workbenches");
            var workbench = workbenches.get(currentWorkbenchCid);
            var vesselCid = workbench.get("currentVesselCid");
            var vessel = workbench.get("vesselCollection").get(vesselCid);
            var solution = vessel.get("solution");
            var pre = solution.clone();
            var channel = postal.channel("logger");
            channel.publish("actionUsed", {name: "PRECIPITATE", relevantInfo: {pre: pre, post: solution}});
            solution.pourAwayLiquid(solution.liquidVolume);
            vessel.set("solution", solution);
            vessel.set("species", solution.getSpeciesData());
            vessel.set("volume", solution.getVolume());
            vessel.set("solidVolume", solution.getSolidVolume());
            vessel.setVolumeString();
            var instrumentPanel = this.model.get("instrumentPanelView");
            instrumentPanel.update(vessel);
        },
        detailView: function (event) {
            var currentWorkbenchCid = this.model.get("currentWorkbenchCid");
            var workbenches = this.model.get("workbenches");
            var workbench = workbenches.get(currentWorkbenchCid);
            var vesselCid = workbench.get("currentVesselCid");
            var vessel = workbench.get("vesselCollection").get(vesselCid);
            vessel.set("detailView", !vessel.get("detailView"));
        },
        duplicateVessel: function (event) {
            if ($(event.target).hasClass("editItem")) {
                $("#edit").dropdown("toggle");
            }
            var currentWorkbenchCid = this.model.get("currentWorkbenchCid");
            var workbenches = this.model.get("workbenches");
            var workbench = workbenches.get(currentWorkbenchCid);
            var vesselCid = workbench.get("currentVesselCid");
            $("#" + vesselCid).removeClass("selectedVessel");
            var vessel = workbench.get("vesselCollection").get(vesselCid);
            var s = vessel.get("solution");
            var speciesData = s.getSpeciesData();
            var i;
            for (i = 0; i < speciesData.length; i++) {
                speciesData[i].amount = speciesData[i].moles;
                delete speciesData[i].moles;
            }
            var solution = {
                description: s.description,
                kb: s.kb,
                name: s.name,
                species: speciesData,
                vessel: vessel.get("vessel").name,
                volume: s.liquidVolume,
                solidVolume: s.getSolidVolume(),
                temperature: s.getTemperature(),
                insulated: s.insulated
            };
            workbench.addSolution(solution, solution.vessel);
            vesselCid = workbench.get("currentVesselCid");
            $("#" + vesselCid).addClass("selectedVessel");
        },
        vesselThermalProperties: function (event) {
            if ($(event.target).hasClass("editItem")) {
                $("#edit").dropdown("toggle");
            }
            var currentWorkbenchCid = this.model.get("currentWorkbenchCid");
            var workbenchDOM = $("#" + currentWorkbenchCid);
            var workbenches = this.model.get("workbenches");
            var workbench = workbenches.get(currentWorkbenchCid);
            var vesselCid = workbench.get("currentVesselCid");
        
            var vesselDOM = $("#" + vesselCid);





            var workbenchViews = this.model.get("workbenchViews");
            var workbenchView = workbenchViews[currentWorkbenchCid];
            var vessel = workbench.get("vesselCollection").get(vesselCid);
            vessel.set('draggable', false);
            var instrumentPanel = this.model.get("instrumentPanelView");
            var solution = vessel.get("solution");
            var left, top;
            if (vesselDOM.position().left + vesselDOM.width() + 322 > workbenchDOM.width()) {
                left = workbenchDOM.width() - 322;
                if (vesselDOM.position().top > workbenchDOM.height() / 2) {
                    top = vesselDOM.position().top - 106;
                }
                else {
                    top = vesselDOM.position().top + vesselDOM.height();
                }
            }
            else {
                left = vesselDOM.position().left + vesselDOM.width();
                top = vesselDOM.position().top;
            }
            var popover = $("#vesselThermalPropertiesPopover");
            popover.css('display', 'block');
            popover.css('top', top);
            popover.css('left', left);
            var insulated = $("#vesselInsulatedInput");
            insulated.prop("checked", solution.insulated);
            var cancel = $("#cancelThermalButton");
            var temperatureInput = $("#vesselTemperatureInput");
            temperatureInput.focus();
            var warning = $("#inputWarning");
            cancel.unbind('click');
            cancel.one('click', function(){
                vessel.set('draggable', true)
                popover.css('display', 'none');
                temperatureInput.val("");
                warning.css("display", "none");
            });
            var button = $("#vesselThermalPropertiesButton");
            button.unbind('click');
            button.on('click', function(){
                if (temperatureInput.val() === "") {
                vessel.set('draggable', true)
                    solution.setInsulated(insulated.is(":checked"));
                    workbenchView.render();
                    instrumentPanel.update(vessel);
                    popover.css('display', 'none');
                    temperatureInput.val("");
                    warning.css("display", "none");
                }
                else {
                    var temperature = parseFloat(temperatureInput.val());
                    if (isNaN(temperature) || temperature <= -273.15) {
                        warning.html("Please enter a valid temperature in degrees Celsius.");
                        warning.css("display", "block");
                    }
                    else {
                        vessel.set('draggable', true)
                        solution.setInsulated(insulated.is(":checked"));
                        solution.changeTemperature(temperature + 273.15);
                        solution.findEquilibriumTemp();
                        vessel.set("temperature", solution.getTemperature());
                        var speciesData = solution.getSpeciesData();
                        vessel.set("species", speciesData);
                        vessel.set("pH", solution.getPH());
                        vessel.set("solution", solution);
                        workbenchView.render();
                        instrumentPanel.update(vessel);
                        popover.css('display', 'none');
                        temperatureInput.val("");
                        warning.css("display", "none");
                    }
                }
                var channel = postal.channel("logger");
                channel.publish("solutionChanged", {source: solution, eventType: "INSULATION"});
            });
            temperatureInput.keypress(function(event) {
                if (event.which == 13) {
                    event.preventDefault();
                    if (temperatureInput.val() === "") {
                        vessel.set('draggable', true)
                        solution.setInsulated(insulated.is(":checked"));
                        workbenchView.render();
                        instrumentPanel.update(vessel);
                        popover.css('display', 'none');
                        temperatureInput.val("");
                        warning.css("display", "none");
                    }
                    else {
                        var temperature = parseFloat(temperatureInput.val());
                        if (isNaN(temperature) || temperature <= -273.15) {
                            warning.html("Please enter a valid temperature in degrees Celsius.");
                            warning.css("display", "block");
                        }
                        else {
                            vessel.set('draggable', true)
                            solution.setInsulated(insulated.is(":checked"));
                            solution.changeTemperature(temperature + 273.15);
                            solution.findEquilibriumTemp();
                            vessel.set("temperature", solution.getTemperature());
                            var speciesData = solution.getSpeciesData();
                            vessel.set("species", speciesData);
                            vessel.set("pH", solution.getPH());
                            vessel.set("solution", solution);
                            workbenchView.render();
                            instrumentPanel.update(vessel);
                            popover.css('display', 'none');
                            temperatureInput.val("");
                            warning.css("display", "none");
                        }
                    }
                    var channel = postal.channel("logger");
                    channel.publish("solutionChanged", {source: solution, eventType: "INSULATION"});
                }
            });
        },
        renameVessel: function (event) {
            if ($(event.target).hasClass("editItem")) {
                $("#edit").dropdown("toggle");
            }
            var currentWorkbenchCid = this.model.get("currentWorkbenchCid");
            var workbenchDOM = $("#" + currentWorkbenchCid);
            var workbenches = this.model.get("workbenches");
            var workbench = workbenches.get(currentWorkbenchCid);
            var vesselCid = workbench.get("currentVesselCid");
            var vesselDOM = $("#" + vesselCid);
            
            var workbenchViews = this.model.get("workbenchViews");
            var workbenchView = workbenchViews[currentWorkbenchCid];
            var vessel = workbench.get("vesselCollection").get(vesselCid);
            vessel.set('draggable', false);
            var instrumentPanel = this.model.get("instrumentPanelView");
            var left, top;
            if (vesselDOM.position().left + vesselDOM.width() + 356 > workbenchDOM.width()) {
                left = workbenchDOM.width() - 356;
                if (vesselDOM.position().top > workbenchDOM.height() / 2) {
                    top = vesselDOM.position().top - 59;
                }
                else {
                    top = vesselDOM.position().top + vesselDOM.height();
                }
            }
            else {
                left = vesselDOM.position().left + vesselDOM.width();
                top = vesselDOM.position().top;
            }
            var popover = $("#renameVesselPopover");
            popover.css('display', 'block');
            popover.css('top', top);
            popover.css('left', left);
            var cancel = $("#cancelRenameVesselButton");
            var input = $("#renameVesselInput");
            input.focus();
            cancel.unbind('click');
            cancel.one('click', function() {
                vessel.set('draggable', true)
                popover.css('display', 'none');
                input.val("");
            });
            var button = $("#renameVesselButton");
            button.unbind('click');
            button.on('click', function(event){
                vessel.set('draggable', true)
                var solution = vessel.get("solution");
                var original = solution.clone();
                solution.name = input.val();
                var channel = postal.channel("logger");
                channel.publish("solutionChanged", {original: original, source: solution, eventType: "NAME"});
                vessel.set("solution", solution);
                vessel.set("name", input.val());
                workbenchView.render();
                instrumentPanel.update(vessel);
                popover.css('display', 'none');
                input.val("");
            });
            input.keypress(function(event) {
                if (event.which == 13) {
                    event.preventDefault();
                    vessel.set('draggable', true);
                    var solution = vessel.get("solution");
                    var original = solution.clone();
                    solution.name = input.val();
                    var channel = postal.channel("logger");
                    channel.publish("solutionChanged", {original: original, source: solution, eventType: "NAME"});
                    vessel.set("solution", solution);
                    vessel.set("name", input.val());
                    workbenchView.render();
                    instrumentPanel.update(vessel);
                    popover.css('display', 'none');
                    input.val("");
                }
            });
        },
        removeVessel: function (event) {
            if ($(event.target).hasClass("editItem")) {
                $("#edit").dropdown("toggle");
            }
            var currentWorkbenchCid = this.model.get("currentWorkbenchCid");
            var workbenches = this.model.get("workbenches");
            var workbench = workbenches.get(currentWorkbenchCid);
            var vesselCid = workbench.get("currentVesselCid");
            var vesselCollection = workbench.get("vesselCollection");
            var channel = postal.channel("logger");
            channel.publish("componentsRemoved", {components: [vesselCollection.get(vesselCid)], workbench: workbench});
            vesselCollection.remove(vesselCid);
            var vesselViews = workbench.get("vesselViews");
            delete vesselViews[vesselCid];
            var workbenchViews = this.model.get("workbenchViews");
            var workbenchView = workbenchViews[currentWorkbenchCid];
            workbenchView.render();
            var instrumentPanel = this.model.get("instrumentPanelView");
            instrumentPanel.update();
            $(".viewerList").find(".viewDivider").remove();
            this.showStockroom();
            // $("#view").addClass("disabled");
        },
        removeTool: function (event) {
            if ($(event.target).hasClass("editItem")) {
                $("#edit").dropdown("toggle");
            }
            var toolCid = $(event.target).attr("id");
            var currentWorkbenchCid = this.model.get("currentWorkbenchCid");
            var workbenches = this.model.get("workbenches");
            var workbench = workbenches.get(currentWorkbenchCid);
            var toolCollection = workbench.get("toolCollection");
            var channel = postal.channel("logger");
            channel.publish("componentsRemoved", {components: [toolCollection.get(toolCid)], workbench: workbench});
            toolCollection.remove(toolCid);
            var toolViews = workbench.get("toolViews");
            delete toolViews[toolCid];
            var workbenchViews = this.model.get("workbenchViews");
            var workbenchView = workbenchViews[currentWorkbenchCid];
            workbenchView.render();
        },
        updateVessels: function () {
            var workbenchCollection = this.model.get("workbenches");
            var workbenches = workbenchCollection.models;
            //var userScaleFactor = this.model.get("userScaleFactor");
            var i, j;
            for (i = 0; i < workbenches.length; i++) {
                //workbenches[i].set("userScaleFactor", userScaleFactor);
                var vesselCollection = workbenches[i].get("vesselCollection").models;
                for (j = 0; j < vesselCollection.length; j++) {
                    var vessel = vesselCollection[j];
                    //vessel.set('userScaleFactor', userScaleFactor);
                    var solution = vessel.get("solution");
                    if (solution !== null) {
                        solution.findEquilibriumTemp();
                        vessel.set('solution', solution);
                        vessel.set('species', solution.getSpeciesData());
                        vessel.set('pH', solution.getPH());
                        vessel.set('temperature', solution.getTemperature());
                        vessel.set('color', solution.getColor());
                        vessel.set('solidVolume', solution.getSolidVolume());
                        vessel.set('solidColor', solution.getSolidColor());

                    }
                    if (vessel.get("timedTracking")) {
                        vessel.recordProperties();
                    }
                }
                // _.each(workbenches[i].get("toolViews"), function(tool){
                //     tool.render();
                // });
            }
            var currentWorkbenchCid = this.model.get("currentWorkbenchCid");
            var workbench = workbenchCollection.get(currentWorkbenchCid);
            var currentVesselCid = workbench.get("currentVesselCid");
            var vesselCollection = workbench.get("vesselCollection");
            var vessel = vesselCollection.get(currentVesselCid);
            if (vessel) {
                var instrumentPanel = this.model.get("instrumentPanelView");
                instrumentPanel.update(vessel);
            }
            setTimeout(_.bind(this.updateVessels, this), 150);
        },
        showAssignmentModal: function () {
            $("#file").dropdown("toggle");
            var assignmentView = this.model.get("assignmentView");
            assignmentView.remove();
            var modal = $(require("ejs-loader!../templates/assignmentModal.ejs")({terms: lang.assignmentModal, language: language}));
            modal.modal({backdrop:false});
            this.$el.append(modal);
            assignmentView.setElement(modal.find("#assignments"));
            assignmentView.render();
            $("#assignmentModal").on("hidden.bs.modal", function(){
                $("body").removeClass("modal-open");
                $(".modal-backdrop").remove();
                $("#assignmentModal").remove();
            });
        },
        showAssignmentTextModal: function () {
            var modal = $(require("ejs-loader!../templates/AssignmentTextModal.ejs")({
                name: this.assignmentName,
                text: this.assignmentText
            }));
            this.$el.append(modal);
            modal.modal({backdrop:false});
            $("#assignmentTextModal").on("hidden.bs.modal", function(){
                $("body").removeClass("modal-open");
                $(".modal-backdrop").remove();
                $("#assignmentTextModal").remove();
            });
        },
        clearWorkbench: function (event) {
            if ($(event.target).hasClass("editItem")) {
                $("#edit").dropdown("toggle");
            }
            var currentWorkbenchCid = this.model.get("currentWorkbenchCid");
            var workbenches = this.model.get("workbenches");
            var workbench = workbenches.get(currentWorkbenchCid);
            var channel = postal.channel("logger");
            channel.publish("componentsRemoved", {components: workbench.get("vesselCollection").models.concat(workbench.get("toolCollection").models), workbench: workbench});
            workbench.set("vesselCollection", new VesselCollection());
            workbench.set("vesselViews", {});
            workbench.set("toolCollection", new ToolCollection());
            workbench.set("toolViews", {});
            var workbenchViews = this.model.get("workbenchViews");
            var workbenchView = workbenchViews[currentWorkbenchCid];
            workbenchView.render();
            var instrumentPanel = this.model.get("instrumentPanelView");
            instrumentPanel.update();
            this.showStockroom();
            $(".viewerList").find(".viewDivider").remove();
            // $("#view").addClass("disabled");
        },
        getVersionString: function () {
            var v = this.majorVersion + "." + this.minorVersion + "." + this.buildNumber;
            if (this.versionFlag !== null && this.versionFlag.length() > 0) {
                v += "-";
                v += this.versionFlag;
            }
            v += " (" + this.buildDate + ")";
            return v;
        },
        renameWorkbench: function () {
            $("#file").dropdown("toggle");
            var modal = $(require('ejs-loader!../templates/RenameWorkbenchModal.ejs')({terms: _.extend({}, lang.nav, lang.actions, lang.workbench), language: language}));
            modal.modal({backdrop:false});
            this.$el.append(modal);
            var input = $("#renameWorkbenchInput");
            modal.on('shown.bs.modal', function () {
                input.focus()
            });
            var button = $("#renameWorkbenchButton");
            button.unbind('click');
            button.on('click', function(){
                var currentWorkbenchCid = this.model.get("currentWorkbenchCid");
                var workbenches = this.model.get("workbenches");
                var workbench = workbenches.get(currentWorkbenchCid);
                workbench.set("displayName", input.val());
                modal.modal('hide');
                $('body').removeClass('modal-open');
                $('.modal-backdrop').remove();
                modal.remove();
                this.model.renderCurrentWorkbench();
            }.bind(this));
            input.keypress(function(event) {
                if (event.which == 13) {
                    event.preventDefault();
                    var currentWorkbenchCid = this.model.get("currentWorkbenchCid");
                    var workbenches = this.model.get("workbenches");
                    var workbench = workbenches.get(currentWorkbenchCid);
                    workbench.set("displayName", input.val());
                    modal.modal('hide');
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();
                    modal.remove();
                    this.model.renderCurrentWorkbench();
                }
            }.bind(this));
        },
        changeLanguage: function () {
            var modal = $(require("ejs-loader!../templates/LanguageModal.ejs")({languageList: lang.languageList}));
            modal.modal({backdrop:false});
            this.$el.append(modal);
            $("#"+language).toggleClass("disabled", true);
            $(".list-group-item").unbind("click");
            $(".list-group-item").on("click", function(e){
                language = e.target.id;
                this.initialize();
            }.bind(this));
            $("#"+language).unbind("click");
            modal.on("hidden.bs.modal", function(){
                $("body").removeClass("modal-open");
                $('.modal-backdrop').remove();
                $(this).remove();
            });
        },
        toggleNavbar: function () {
            $(".collapse").collapse("toggle");
        },
        isFinishedLoading: function () {
            return this.finishedLoading;
        },
        getSelectedVessel: function () {
            var currentWorkbenchCid = this.model.get("currentWorkbenchCid");
            var workbenches = this.model.get("workbenches");
            var workbench = workbenches.get(currentWorkbenchCid);
            var vesselCid = workbench.get("currentVesselCid");
            var vesselCollection = workbench.get("vesselCollection");
            var vessel = vesselCollection.get(vesselCid);
            return XMLUtility.xmlFlask(vessel).join("");
        },
        getWorkbenchItems: function () {
            var currentWorkbenchCid = this.model.get("currentWorkbenchCid");
            var workbenches = this.model.get("workbenches");
            var workbench = workbenches.get(currentWorkbenchCid);
            var array = [];
            var vessels = workbench.get("vesselCollection").models;
            var i;
            for (i = 0; i < vessels.length; i++) {
                array.push(XMLUtility.xmlFlask(vessels[i]).join(""));
            }
            var tools = workbench.get("toolCollection").models;
            for (i = 0; i < tools.length; i++) {
                array.push(XMLUtility.xmlComponent(tools[i]).join(""));
            }
            return array.join("");
        },
        toggleHelp: function () {
            $("#help").dropdown("toggle");
        },
        presentationMode: function () {
            $("#view").dropdown("toggle");
            $("#instrumentPanelContainer").toggleClass("presentation");
            $("#stockroomContainer").toggleClass("presentation");
            var checkmark = $("#presentationMode").find(".glyphicon");
            if (checkmark.css("display") === "none") {
                checkmark.css("display","inline-block");
            }
            else {
                checkmark.css("display","none");
            }
        },
        zoomOut: function () {
            $("#view").dropdown("toggle");
            //var sf = this.model.get("userScaleFactor");
            var sf = Configuration.userScaleFactor;
            sf -= 0.2;
            if (Math.floor(sf*10) <= 4) {
                sf = 0.4;
                $("#workbenchZoomOut").css("display", "none");
            }
            if (Math.floor(sf*10) === 10)
                $("#workbenchResetZoom").css("display", "none");
            else $("#workbenchResetZoom").css("display", "block");
            $("#workbenchZoomIn").css("display", "block");
            //this.model.set("userScaleFactor", sf);
            Configuration.userScaleFactor = sf;
            this.updateVessels();
        },
        zoomIn: function () {
            $("#view").dropdown("toggle");
            //var sf = this.model.get("userScaleFactor");
            var sf = Configuration.userScaleFactor;
            sf += 0.2;
            if (Math.floor(sf*10) >= 20) {
                sf = 2.0;
                $("#workbenchZoomIn").css("display", "none");
            }
            if (Math.floor(sf*10) === 10)
                $("#workbenchResetZoom").css("display", "none");
            else $("#workbenchResetZoom").css("display", "block");
            $("#workbenchZoomOut").css("display", "block");
            //this.model.set("userScaleFactor", sf);
            Configuration.userScaleFactor = sf;
            this.updateVessels();
        },
        resetZoom: function () {
            $("#view").dropdown("toggle");
            Configuration.userScaleFactor  = 1.0;
            $("#workbenchResetZoom").css("display", "none");
        }
    });

    return AppView;
});
